import React, { useRef } from 'react';
import cn from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Image from 'next/image';
import Spline from '@splinetool/react-spline';

import Logo from 'react-scale/components/website/Logo';
import CTA from 'react-scale/components/elements/cta';

const HeroWithSpline = ({ icon, overtitle, title, product, subtitle, cta, spline, children }) => {
  const canvas = useRef();

  return (
    <div>
      {children}
      <div className="relative text-white bg-black">
        <div className="relative">
          <div className="container flex flex-col items-center w-full py-10 lg:flex-row lg:justify-between lg:gap-10 lg:py-16">
            <div className={cn('w-full', product ? 'lg:w-5/12' : 'lg:w-6/12')}>
              <div className={cn({ 'flex gap-8': icon?.src && product })}>
                {icon?.src && (
                  <div className={cn('relative', { 'w-16 h-16 mb-4': !product })}>
                    <Image src={icon?.src} alt={icon.alt} width={icon.width} height={icon.height} />
                  </div>
                )}
                <div>
                  {overtitle && (
                    <h4 className="inline-block mb-4 text-overtitle-sm text-gradient">
                      {overtitle}
                    </h4>
                  )}
                  {product && icon?.src && (
                    <div className="mb-6">
                      <Logo width="82px" fill="#A3A3A3" />
                    </div>
                  )}
                  <h1
                    className={cn(
                      'font-aeonik md:text-6xl',
                      product ? 'text-5xl font-light' : 'text-4xl',
                      { 'md:text-5.5xl': icon?.src && product }
                    )}
                  >
                    {title} <span className="text-gradient">{product}</span>
                  </h1>
                </div>
              </div>
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className={cn('mt-6 text-base lg:text-xl', product ? 'lg:w-3/4' : 'w-full')}
              >
                {subtitle}
              </ReactMarkdown>
              <div className="mt-12 mb-12 lg:w-3/4 lg:mb-0">
                <CTA cta={cta} />
              </div>
            </div>

            <div className="hidden lg:block shrink-0 lg:w-[500px] lg:h-[500px] xl:w-[550px] xl:h-[550px] 3xl:w-[600px] 3xl:h-[600px]">
              <Spline
                ref={canvas}
                scene={spline}
                className="transition duration-500 !w-[inherit] !h-[inherit]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroWithSpline;
